import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";

import ArticleSection from "./sections/articleSection/ArticleSection";
import ProxiesArticle from "./sections/articleSection/ProxiesArticle";
import OtherArticlesSection from "./sections/otherArticlesSection/OtherArticlesSection";



const articles: Record<string, JSX.Element> = {
	"retrodrops": <ArticleSection />,
	"proxies": <ProxiesArticle />,
	"third-article": <ArticleSection />,
};

export default function Article() {
	const { slug } = useParams<{ slug: string }>();

	const articleBody = slug ? articles[slug] : undefined;


	const handleScrollToTop = () => {
		window.scrollTo(0, 0);
	}

	useEffect(() => {
		handleScrollToTop();
	}, [slug]);


	if (!articleBody) return <Navigate to="/blog" replace />;

	return (
		<div className="article">
			<Header mode="dark" />
			{articleBody}
			<OtherArticlesSection currentSlug={slug!}/>
			<FooterSection />
		</div>
	);
}